// src/components/layout/Footer.jsx
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#050505] border-t border-white/5 pt-16 pb-8 font-sans mt-auto">
      <div className="max-w-[95rem] mx-auto px-6 lg:px-12">
        
        {/* Sección Superior: Grid de Contenido */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          
          {/* Columna 1: Marca y Misión */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-4 group mb-6">
              <div className="w-10 h-10 flex items-center justify-center border border-[#C5A059]/50 transition-colors group-hover:border-[#C5A059]">
                <span className="font-serif font-bold text-xl text-[#C5A059]">G</span>
              </div>
              <div>
                <h2 className="font-serif text-lg font-semibold tracking-[0.2em] uppercase text-white leading-none">
                  Gran Logia <span className="font-light text-[#C5A059]">Perú</span>
                </h2>
              </div>
            </Link>
            <p className="text-gray-400 text-sm font-light max-w-sm leading-relaxed">
              Custodiamos un legado histórico que impulsa el desarrollo intelectual y moral, forjando a través de la ciencia, la justicia y el trabajo.
            </p>
          </div>

          {/* Columna 2: Navegación Rápida */}
          <div>
            <h3 className="text-white text-xs tracking-[0.2em] uppercase mb-6 font-semibold">Descubrir</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/nosotros/historia" className="text-gray-400 hover:text-white text-sm transition-colors font-light">Nuestra Historia</Link>
              </li>
              <li>
                <Link to="/organismos/instituto-historico" className="text-gray-400 hover:text-white text-sm transition-colors font-light">Instituto Histórico</Link>
              </li>
              <li>
                <Link to="/despacho" className="text-gray-400 hover:text-white text-sm transition-colors font-light">Trámites y Despacho</Link>
              </li>
              <li>
                <Link to="/intranet" className="text-[#C5A059] hover:text-white text-sm transition-colors font-light">Acceso Intranet</Link>
              </li>
            </ul>
          </div>

          {/* Columna 3: Contacto */}
          <div>
            <h3 className="text-white text-xs tracking-[0.2em] uppercase mb-6 font-semibold">Sede Histórica</h3>
            <ul className="space-y-4 text-sm text-gray-400 font-light">
              <li>Av. José Gálvez Barrenechea 599 - <br />San Isidro - Lima - Perú</li>
              <li>
                <a href="mailto:webmaster@glperu.org.pe" className="hover:text-[#C5A059] transition-colors">
                  webmaster@glperu.org.pe
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Sección Inferior: Copyright y Legales */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-[11px] tracking-wider uppercase">
            &copy; {new Date().getFullYear()} Gran Logia del Perú. Todos los derechos reservados.
          </p>
          <div className="flex gap-6 text-[11px] text-gray-500 tracking-wider uppercase">
            <a href="#" className="hover:text-[#C5A059] transition-colors">Políticas de Privacidad</a>
            <a href="#" className="hover:text-[#C5A059] transition-colors">Términos de Uso</a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;